<template>
  <!-- Section header toggle (Map Fields accordion): chevron + overline title. -->
  <button
    type="button"
    class="riw-acc-btn"
    :aria-expanded="String(open)"
    :aria-controls="controls"
    @click="$emit('toggle')">
    <v-icon class="riw-acc-btn__chev" size="18">mdi-chevron-down</v-icon>
    <span class="riw-overline">{{ label }}</span>
  </button>
</template>

<script>
/**
 * Header button of a collapsible Map Fields section (Settings, Facility name mapping, Column
 * mapping). The parent owns the open state; the controlled region stays in the DOM (`hidden`).
 * Pass `id` as a plain attribute so the section can be `aria-labelledby` this button.
 */
export default {
  name: 'ImportSectionToggle',
  props: {
    open: { type: Boolean, default: true },
    label: { type: String, required: true },
    /** id of the region this button shows / hides */
    controls: { type: String, required: true },
  },
  methods: {
    focus() {
      this.$el.focus();
    },
  },
};
</script>
